import {Component} from 'react'
import {IoIosSearch} from 'react-icons/io'
import Loader from 'react-loader-spinner'
import {formatDistanceToNow} from 'date-fns'
import Cookie from 'js-cookie'

import Header from '../Header'
import Banner from '../Banner'
import Sidebar from '../Sidebar'
import HomePageVideosContainer from '../HomePageVideosContainer'

import {
  LoaderContainer,
  RetryBtn,
  FailureContent,
  FailureHeading,
  NoVideoImg,
  NonVideoContainer,
  SearchBtn,
  SearchInput,
  SearchContainer,
  SearchAndVideosContainer,
  HomeNonHeaderContainer,
  HomeBgContainer,
  BannerAndVideosContainer,
} from './styledComponents'
import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

const apiStatus = {
  initial: 'INITIAL',
  inProgress: 'IN_PROGRESS',
  success: 'SUCCESSFUL',
  failed: 'FAILURE',
}

class Home extends Component {
  state = {
    searchInp: '',
    videosList: [],
    fetchStatus: apiStatus.initial,
  }

  componentDidMount() {
    this.setState({fetchStatus: apiStatus.inProgress})
    this.fetchVideos()
  }

  fetchVideos = async () => {
    const token = Cookie.get('jwt_token')
    const options = {
      headers: {Authorization: `Bearer ${token}`},
    }
    const {searchInp} = this.state
    const response = await fetch(
      `https://apis.ccbp.in/videos/all?search=${searchInp}`,
      options,
    )
    if (response.ok) {
      const data = await response.json()
      const updatedList = data.videos.map(eachItem => ({
        id: eachItem.id,
        title: eachItem.title,
        thumbnailUrl: eachItem.thumbnail_url,
        channel: {
          name: eachItem.channel.name,
          profileImgUrl: eachItem.channel.profile_image_url,
        },
        viewCount: eachItem.view_count,
        publishedDuration: formatDistanceToNow(new Date(eachItem.published_at)),
      }))
      this.setState({
        fetchStatus: apiStatus.success,
        videosList: updatedList,
      })
    } else {
      this.setState({fetchStatus: apiStatus.failed})
    }
  }

  onChangeSearchInp = event => this.setState({searchInp: event.target.value})

  render() {
    const {searchInp} = this.state

    return (
      <NxtWatchContext.Consumer>
        {value => {
          const {darkMode} = value

          const renderFailedView = () => {
            const imgUrl = darkMode
              ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png'
              : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png'
            return (
              <NonVideoContainer>
                <NoVideoImg src={imgUrl} alt="failure view" />
                <FailureHeading darkMode={darkMode}>
                  Oops! Something Went Wrong
                </FailureHeading>
                <FailureContent darkMode={darkMode}>
                  We are having some trouble to complete your request. Please
                  try again.
                </FailureContent>
                <RetryBtn type="button" onClick={this.fetchVideos}>
                  Retry
                </RetryBtn>
              </NonVideoContainer>
            )
          }

          const renderNotFoundView = () => (
            <NonVideoContainer darkMode={darkMode}>
              <NoVideoImg
                src="https://assets.ccbp.in/frontend/react-js/nxt-watch-no-search-results-img.png"
                alt="no videos"
              />
              <FailureHeading darkMode={darkMode}>
                No Search results found
              </FailureHeading>
              <FailureContent darkMode={darkMode}>
                Try different key words or remove search filter
              </FailureContent>
              <RetryBtn type="button" onClick={this.fetchVideos}>
                Retry
              </RetryBtn>
            </NonVideoContainer>
          )

          const renderLoadingView = () => (
            <LoaderContainer data-testid="loader" darkMode={darkMode}>
              <Loader
                type="ThreeDots"
                color={darkMode ? '#3b82f6' : '#000000'}
                height="50"
                width="50"
              />
            </LoaderContainer>
          )

          const renderRespectiveHomePageVideoContainer = () => {
            const {fetchStatus, videosList} = this.state
            switch (fetchStatus) {
              case apiStatus.failed:
                return renderFailedView()
              case apiStatus.inProgress:
                return renderLoadingView()
              case apiStatus.success:
                if (videosList.length === 0) {
                  return renderNotFoundView()
                }
                return <HomePageVideosContainer videosList={videosList} />
              default:
                return null
            }
          }

          return (
            <HomeBgContainer>
              <Header />
              <HomeNonHeaderContainer>
                <Sidebar />
                <BannerAndVideosContainer>
                  <Banner />
                  <SearchAndVideosContainer
                    data-testid="home"
                    darkMode={darkMode}
                  >
                    <SearchContainer>
                      <SearchInput
                        type="search"
                        value={searchInp}
                        placeholder="Search"
                        onChange={this.onChangeSearchInp}
                      />
                      <SearchBtn
                        darkMode={darkMode}
                        type="button"
                        onClick={this.fetchVideos}
                        data-testid="searchButton"
                      >
                        <IoIosSearch />
                      </SearchBtn>
                    </SearchContainer>
                    {renderRespectiveHomePageVideoContainer()}
                  </SearchAndVideosContainer>
                </BannerAndVideosContainer>
              </HomeNonHeaderContainer>
            </HomeBgContainer>
          )
        }}
      </NxtWatchContext.Consumer>
    )
  }
}
export default Home
